import { render, staticRenderFns } from "./LeaveApprovalsTable.vue?vue&type=template&id=4e4b0b80&"
import script from "./LeaveApprovalsTable.vue?vue&type=script&lang=js&"
export * from "./LeaveApprovalsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports